import { useDispatch, useSelector } from "react-redux"
import { selectTranslations } from "../../../App/i18n/i18nSlice"
import { CloseIcon } from "../../Shared/Components/SvgIcons"
import Button from "../../Shared/Primitive/Button"
import { setModalData } from "../../Shared/SharedSlices/ModalSlice"
import { RootState } from "../../../App/store"
import { EditorModifier, RoleType, StorageKey } from "../../../App/enums"
import HTTPService from "../../../App/HTTPService"
import TextInput from "../../Shared/Primitive/TextInput"
import Checkbox from "../../Shared/Primitive/Checkbox"
import CharacterCounter from "../../Shared/Components/CharacterCounter"
import React, { useEffect, useRef } from "react"
import EditorTextArea from "../../Shared/Components/Editor/EditorTextArea"
import { Editor as TinyMCEEditor } from "tinymce"
import { htmlRegex } from "../../../App/Regex"
import SingleTextInput from "../../Shared/Components/SingleTextInput"
import HashtagInput from "../../Shared/Components/HashtagInput"
import { headers } from "../../../App/Axios"
import SessionService from "../../../App/SessionService"
import { roomPostPostRequest } from "../RoomPost/RoomPostRequests"
import { Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react"
import { createEventRequest, updateEventRequest } from "../RoomServiceRequests/EventServiceRequest"
import { setRoomEventsData } from "../RoomSlices/RoomEventsSlice"
import Dropdown from "../../Shared/Primitive/Dropdown"
import { formatDate } from "../../../App/Helpers/Helpers"
import { setRoomData } from "../../Shared/SharedSlices/RoomSlice"

function RoomCreateEventModal(props: {
    createEvent?: boolean,
    editEvent?: boolean
}) {
    const roomDataState = useSelector((state: RootState) => state.roomSlice.roomSlice.room)
    const organizationDataState = useSelector((state: RootState) => state.organizationsSlice.organizationSlice.organization)
    const userDataState = useSelector((state: RootState) => state.userDataSlice)
    const posts = useSelector((state: RootState) => state.RoomPostsSlice.roomPostsSlice.posts)

    const [name, setName] = React.useState("")
    const [description, setDescription] = React.useState("")
    const [fileselected, setFileSelected] = React.useState(false)
    const [file, setFile] = React.useState<any>(null)
    const [fileName, setFileName] = React.useState("")

    const [formatId, setFormatId] = React.useState<number>(0)
    const [locationTypeId, setLocationTypeId] = React.useState<number>(0)
    const [admission, setAdmission] = React.useState("")
    const [registrationLink, setRegistrationLink] = React.useState("")
    const [accessLink, setAccessLink] = React.useState("")
    const [mail, setMail] = React.useState("")
    const [website, setWebsite] = React.useState("")
    const [beginDate, setBeginDate] = React.useState<Date | null>(null)
    const [endDate, setEndDate] = React.useState<Date | null>(null)
    const [keywords, setKeywords] = React.useState<string[]>([])
    const [locationDetails, setLocationDetails] = React.useState("")

    const roomId = roomDataState.id
    const translation = useSelector(selectTranslations)
    const dispatch = useDispatch()

    const roomEventsState = useSelector((state: RootState) => state.roomEventsSlice)


    const [notificationText, setNotificationText] = React.useState("")
    const [descriptionError, setDescriptionError] = React.useState("")
    const [nameError, setNameError] = React.useState("")
    const [startDateError, setStartDateError] = React.useState("")
    const [endDateError, setEndDateError] = React.useState("")
    const [keywordsError, setKeywordsError] = React.useState("")
    const [admissionError, setAdmissionError] = React.useState("")
    const [websiteError, setWebsiteError] = React.useState("")
    const [accessLinkError, setAccessLinkError] = React.useState("")
    const [registrationLinkError, setRegistrationLinkError] = React.useState("")
    const [locationTypeError, setLocationTypeError] = React.useState("")
    const [locationDetailsError, setLocationDetailsError] = React.useState("")
    const [formatError, setFormatError] = React.useState("")
    const [mailError, setMailError] = React.useState("")
    const editorRef = useRef<TinyMCEEditor | null>(null)
    const editorRef2 = useRef<TinyMCEEditor | null>(null)
    const textWithoutHtml = description?.replaceAll(htmlRegex, "")
    const [isSubmitting, setIsSubmitting] = React.useState(false)
    const [serverError, setServerError] = React.useState("")
    const [isOrgAdmin, setIsOrgAdmin] = React.useState(false)
    const [sendNotification, setSendNotification] = React.useState(false)
    const role = useSelector((state: RootState) => state.rolesSlice.RolesSlice.roles)
    const orgId = SessionService.getItem(StorageKey.organizationId)

    const locationTypes = [
        { id: 1, name: "Online" },
        { id: 2, name: "Hybrid" },
        { id: 3, name: "Vor Ort" }
    ]

    const formats = [
        { id: 1, name: "Abstimmungsgespräch" },
        { id: 2, name: "Ausstellung" },
        { id: 3, name: "Bar-Camps" },
        { id: 4, name: "Community Call" },
        { id: 5, name: "Fachtagung" },
        { id: 6, name: "Festival" },
        { id: 7, name: "Fortbildung" },
        { id: 8, name: "Hackathon" },
        { id: 9, name: "Infoveranstaltung" },
        { id: 10, name: "Konferenzen" },
        { id: 11, name: "Kongress" },
        { id: 12, name: "Meet-Ups" },
        { id: 13, name: "Messen" },
        { id: 14, name: "Podiumsdiskussion" },
        { id: 15, name: "Sonstiges" },
        { id: 16, name: "Tag der offenen Tür" },
        { id: 17, name: "Webinare" },
        { id: 18, name: "Workshops" }
    ];

    useEffect(() => {
        if (props.editEvent && roomEventsState.selectedItem) {
            setName(roomEventsState.selectedItem.title)
            setDescription(roomEventsState.selectedItem.description)
            editorRef.current?.setContent(roomEventsState.selectedItem.description);
            setAdmission(roomEventsState.selectedItem.admission)
            setRegistrationLink(roomEventsState.selectedItem.registration_link)
            setAccessLink(roomEventsState.selectedItem.access_link)
            setMail(roomEventsState.selectedItem.mail)
            setWebsite(roomEventsState.selectedItem.website)
            setKeywords(roomEventsState.selectedItem.keywords)
            setFormatId(roomEventsState.selectedItem.formats ? formats.find((format) => format.name === roomEventsState.selectedItem?.formats)?.id || 0 : 0)
            setLocationTypeId(locationTypes.find((locationType) => locationType.name === roomEventsState.selectedItem?.location_type)?.id || 0)
            setLocationDetails(roomEventsState.selectedItem.location_details)

            

            if (roomEventsState.selectedItem.start_date) {
                const startDate = new Date(formatDate(roomEventsState.selectedItem.start_date, 'dd.MM.yyyy HH:mm')!);
                setBeginDate(startDate);
                if (roomEventsState.selectedItem.end_date) {
                    const endDate = new Date(formatDate(roomEventsState.selectedItem.end_date, 'dd.MM.yyyy HH:mm')!);
                    setEndDate(endDate);
                }
            }
        }
    }, [props.editEvent, editorRef.current])

    useEffect(() => {
        if (role === RoleType.ORGANIZATION && orgId) {
            editorRef2.current?.setContent(
                `${organizationDataState.name}</a> hat das Event "<a href='/e/${roomId}/#EID#'>${name}</a>" im Eventkalender dieses Raumes für den ${formatDate(beginDate!,'dd.MM.yyyy')} veröffentlicht.`
            )
        } else if (role === RoleType.USER) {
            editorRef2.current?.setContent(`${userDataState.first_name}  ${userDataState.last_name} hat das Event "<a href='/e/${roomId}/#EID#'>${name}</a>" im Eventkalender dieses Raumes für den ${beginDate?.toLocaleDateString()} veröffentlicht.`)
        }
    }, [name, beginDate])

    // Validation logic extracted to a separate function
    const validateForm = () => {
        let hasError = false;

        // Reset errors
        setNameError("");
        setDescriptionError("");
        setStartDateError("");
        setEndDateError("");
        setKeywordsError("");
        setAdmissionError("");
        setWebsiteError("");
        setAccessLinkError("");
        setRegistrationLinkError("");
        setLocationTypeError("");
        setLocationDetailsError("");
        setFormatError("");
        setMailError("");
        setServerError("");

        // Name validation
        if (name.trim().length === 0) {
            setNameError("Dieses Feld ist ein Pflichtfeld.");
            hasError = true;
        }

        // Description validation
        if (!description || description.replaceAll(htmlRegex, "").trim().length === 0) {
            setDescriptionError("Dieses Feld ist ein Pflichtfeld.");
            hasError = true;
        } else if (description.replaceAll(htmlRegex, "").length > 200) {
            setDescriptionError("Maximal 200 Zeichen erlaubt.");
            hasError = true;
        }

        // Format validation
        if (formatId === 0) {
            setFormatError("Dieses Feld ist ein Pflichtfeld.");
            hasError = true;
        }

        // Location type validation
        if (locationTypeId === 0) {
            setLocationTypeError("Dieses Feld ist ein Pflichtfeld.");
            hasError = true;
        }

        // Date validation
        if (!beginDate) {
            setStartDateError("Dieses Feld ist ein Pflichtfeld.");
            hasError = true;
        }
        if (!endDate) {
            setEndDateError("Dieses Feld ist ein Pflichtfeld.");
            hasError = true;
        }
        if (beginDate && endDate && endDate < beginDate) {
            setEndDateError("Das Ende deiner Veranstaltung kann nicht vor dem Anfang liegen.");
            hasError = true;
        }

        // Conditional validation for links and location details
        if ((locationTypeId === 1 || locationTypeId === 2) && registrationLink === "" && accessLink === "") {
            setRegistrationLinkError("Bitte ergänze noch einen Anmelde- oder Zugangslink, damit die Teilnehmenden zu deiner Veranstaltung finden.");
            setAccessLinkError("Bitte ergänze noch einen Anmelde- oder Zugangslink, damit die Teilnehmenden zu deiner Veranstaltung finden.");
            hasError = true;
        }

        if (registrationLink !== "" && !/^https?:\/\/.+\..+/.test(registrationLink)) {
            setRegistrationLinkError("Bitte eine gültige URL für den Anmelde-Link eingeben (inkl. http(s)://).");
            hasError = true;
        }
        if (accessLink !== "" && !/^https?:\/\/.+\..+/.test(accessLink)) {
            setAccessLinkError("Bitte eine gültige URL für den Zugangslink eingeben (inkl. http(s)://).");
            hasError = true;
        }

        if ((locationTypeId === 2 || locationTypeId === 3) && !locationDetails && !registrationLink) {
            setLocationDetailsError("Bitte ergänze noch einen Anmeldelink oder Veranstaltungsort, damit die Teilnehmenden zu deiner Veranstaltung finden.");
            setRegistrationLinkError("Bitte ergänze noch einen Anmeldelink oder Veranstaltungsort, damit die Teilnehmenden zu deiner Veranstaltung finden.");
            hasError = true;

            if (registrationLink && !/^https?:\/\/.+\..+/.test(registrationLink)) {
                setRegistrationLinkError("Bitte eine gültige URL für den Anmelde-Link eingeben (inkl. http(s)://).");
            }
        }
        if (locationTypeId === 3 && !locationDetails) {
            setLocationDetailsError("Bitte ergänze noch einen Veranstaltungsort, damit die Teilnehmenden zu deiner Veranstaltung finden.");
            hasError = true;
        }

        // Email validation (optional, but if present, check format)
        if (mail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail)) {
            setMailError("Bitte eine gültige E-Mail-Adresse eingeben.");
            hasError = true;
        }

        // Website validation (optional, but if present, check format)
        if (website && !/^https?:\/\/.+\..+/.test(website)) {
            setWebsiteError("Bitte eine gültige Website-URL eingeben (inkl. http(s)://).");
            hasError = true;
        }

        if(hasError){
            setServerError("Bitte die markierten Felder überprüfen.")
        }

        return !hasError;
    };

    const onSubmit = (event: { preventDefault: () => void }) => {
        event.preventDefault()
        if (!validateForm()){
            return
        }

        let formData = new FormData()

        setIsSubmitting(true)

        if (role === RoleType.ORGANIZATION && orgId) {
            formData.append("content_type", "organization")
            formData.append("object_id", orgId)
        } else if (role === RoleType.USER) {
            formData.append("content_type", "user")
        }

        formData.append("room", roomDataState.id.toString());
        formData.append("room_id", roomDataState.id.toString());
        formData.append("title", name)
        formData.append("description", description)
        const selectedFormat = formats.find((format) => format.id === formatId);
        formData.append("formats", selectedFormat ? selectedFormat.name : "");
        formData.append("admission", admission)
        formData.append("registration_link", registrationLink)
        const selectedLocationType = locationTypes.find((locationType) => locationType.id === locationTypeId);
        formData.append("location_type", selectedLocationType ? selectedLocationType.name : "");
        formData.append("location_details", locationDetails)
        formData.append("access_link", accessLink)
        formData.append("mail", mail)
        formData.append("website", website)
        formData.append("keywords", JSON.stringify(keywords))
        formData.append("start_date", beginDate ? beginDate.toISOString().slice(0, 16) : "")
        formData.append("end_date", endDate ? endDate.toISOString().slice(0, 16) : "")

        if (file) {
            formData.append("image", file)
        }

        if (props.createEvent) {
            setIsSubmitting(true)
            createEventRequest(roomId, formData).then((response) => {
                if (response.status === 201) {
                    if (sendNotification) {

                        if (notificationText.includes("#EID#")) {
                            let notificationTextWithLink = notificationText.replace("#EID#", response.data.id)
                            editorRef2.current?.setContent(notificationTextWithLink)
                        }
                        const formData = new FormData()

                        const objectId = (role === RoleType.ORGANIZATION ? orgId : userDataState.id)

                        formData.append("content", editorRef2.current!.getContent({ format: 'raw' }))
                        formData.append("content_type", role.toLowerCase())
                        formData.append("object_id", objectId?.toString()!)
                        formData.append("tags", JSON.stringify([]))
                        formData.append("room", roomId.toString())

                        dispatch<any>(roomPostPostRequest(formData, posts))
                    }

                    setIsSubmitting(false)
                    dispatch(setRoomEventsData({
                        ...roomEventsState,
                        items: [...roomEventsState.items, response.data].sort((a, b) => new Date(a.start_date).getTime() - new Date(b.start_date).getTime()),
                        selectedItem: response.data,
                        stats: { ...roomEventsState.stats, total_items: roomEventsState.stats.total_items + 1 }
                    }))
                    dispatch(setRoomData({
                        ...roomDataState,
                        total_events: (roomDataState.total_events ?? 0) + 1
                    }))
                    dispatch(setModalData({ open: false, roomCreateEventModal: {} }))

                }
            }).catch((error) => {
                if (error.response.status === 400) {
                    const errors = error.response.data;

                    if (errors.title) {
                        setNameError(errors.title[0]);
                    }
                    if (errors.start_date) {
                        setStartDateError(errors.start_date[0]);
                    }
                    if (errors.end_date) {
                        setEndDateError(errors.end_date[0]);
                    }
                    if (errors.keywords) {
                        setKeywordsError(errors.keywords[0]);
                    }
                    if (errors.admission) {
                        setAdmissionError(errors.admission[0]);
                    }
                    if (errors.registration_link) {
                        setRegistrationLinkError(errors.registration_link[0]);
                    }
                    if (errors.mail) {
                        setMailError(errors.mail[0]);
                    }
                    if (errors.website) {
                        setWebsiteError(errors.website[0]);
                    }
                    if (errors.formats) {
                        setFormatError(errors.formats[0]);
                    }
                    if (errors.location_type) {
                        setLocationTypeError(errors.location_type[0]);
                    }
                    if (errors.access_link) {
                        setAccessLinkError(errors.access_link[0]);
                    }
                    setServerError("Bitte die markierten Felder überprüfen.")
                } else {
                    setServerError("Ein unerwarteter Fehler ist aufgetreten.")
                }
                console.log(error)
            }).finally(() => {
                setIsSubmitting(false)
            })
        } else if (props.editEvent) {
            updateEventRequest(roomId, roomEventsState.selectedItem!.id, formData).then((response) => {
                if (response.status === 200) {
                    setIsSubmitting(false)
                    dispatch(setRoomEventsData({
                        ...roomEventsState,
                        items: roomEventsState.items
                            .map(item => item.id === response.data.id ? response.data : item)
                            .sort((a, b) => new Date(a.start_date).getTime() - new Date(b.start_date).getTime()),
                        selectedItem: response.data
                    }))
                    dispatch(setModalData({ open: false, roomCreateEventModal: {} }))

                }
            }).catch((error) => {
                if (error.response.status === 400) {
                    const errors = error.response.data;

                    if (errors.title) {
                        setNameError(errors.title[0]);
                    }
                    if (errors.start_date) {
                        setStartDateError(errors.start_date[0]);
                    }
                    if (errors.end_date) {
                        setEndDateError(errors.end_date[0]);
                    }
                    if (errors.keywords) {
                        setKeywordsError(errors.keywords[0]);
                    }
                    if (errors.admission) {
                        setAdmissionError(errors.admission[0]);
                    }
                    if (errors.registration_link) {
                        setRegistrationLinkError(errors.registration_link[0]);
                    }
                    if (errors.mail) {
                        setMailError(errors.mail[0]);
                    }
                    if (errors.website) {
                        setWebsiteError(errors.website[0]);
                    }
                    if (errors.format) {
                        setFormatError(errors.format[0]);
                    }
                    if (errors.location_type) {
                        setLocationTypeError(errors.location_type[0]);
                    }
                    if (errors.access_link) {
                        setAccessLinkError(errors.access_link[0]);
                    }
                    setServerError("Bitte die markierten Felder überprüfen.")
                } else {
                    setServerError("Ein unerwarteter Fehler ist aufgetreten.")
                }
                console.log(error)
            }).finally(() => {
                setIsSubmitting(false)
            })
        }
    }

    const onModalClose = () => {
        dispatch(setModalData({ open: false, roomUploadModal: false }))
    }

    useEffect(() => {
        HTTPService.get(`/role-in-org/${roomDataState.organization?.id}/`, headers).then(response => {
            if (response.status === 200) {
                setIsOrgAdmin(response.data.is_admin)
            }
        })
    }, [roomDataState.organization?.id])

    return (
        <div className="event-modal">
            <div className="event-modal__content">
                <div className="event-modal__upper-panel">
                    <div className="event-modal__title">{props.createEvent ? translation.create_event : translation.edit_event}</div>
                    <div onClick={onModalClose} className="event-modal__close-icon">
                        <CloseIcon />
                    </div>
                </div>
                <div className="event-modal__divider"></div>
                <div className="event-modal__middle-panel">
                    <Tabs className="event-modal__tabs" isFitted variant='enclosed'>
                        <TabList mb='1em'>
                            <Tab color={'#60a49f'}>Allgemeines</Tab>
                            <Tab color={'#60a49f'}>Details</Tab>
                            <Tab color={'#60a49f'}>Speichern</Tab>
                        </TabList>
                        <TabPanels>
                            <TabPanel>
                                <SingleTextInput
                                    textInput={<TextInput
                                        className="room-events__single-text-input"
                                        type="text"
                                        value={name}
                                        textinputsize="small-40"
                                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                            setName(event.target.value)
                                        }}
                                        placeholder={translation.name}
                                        name="name"
                                        autoComplete="off"
                                        maxLength={100}
                                    />}
                                    errorText={nameError}
                                    title={translation.name}
                                />

                                <div className="event-modal__about-container">
                                    <div className="event-modal__max-character-container">
                                        <div className="event-modal__text-area">
                                            <div className="single-text-input__text">
                                                {translation.description}
                                            </div>
                                            <EditorTextArea
                                                inputState={description}
                                                setInputState={setDescription}
                                                editorRef={editorRef}
                                                editorPlaceholder={translation.description}
                                                editorHeight={98}
                                                modifier={EditorModifier.editRoomDescription}
                                                initialEditorValue={''}
                                                setContent={() => { }}
                                                enterPressed={() => { }}
                                            />
                                        </div>

                                        <CharacterCounter current={textWithoutHtml.length} max={200} modifier="" />
                                        <p className="event-modal__error-text">{descriptionError}</p>
                                    </div>
                                </div>

                                <Dropdown
                                    itemId={locationTypeId}
                                    setItemId={setLocationTypeId}
                                    items={locationTypes}
                                    placeholder={translation.chooseLocationType}
                                    tabIndex={locationTypes[0].id}
                                    selectModifier="dropdown__select--unset-width"
                                />
                                <p className="accordion__error-message">{locationTypeError}</p>

                                {(locationTypeId === 1 || locationTypeId === 2) && (
                                    <SingleTextInput
                                        textInput={<TextInput
                                            className="room-events__single-text-input"
                                            type="text"
                                            value={accessLink}
                                            textinputsize="small-40"
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                setAccessLink(event.target.value)
                                            }}
                                            placeholder={translation.accessLink}
                                            name="accessLink"
                                            autoComplete="off"
                                            maxLength={100}
                                        />}
                                        errorText={accessLinkError}
                                        title={translation.accessLink}
                                    />
                                )}

                                {(locationTypeId === 2 || locationTypeId === 3) && (
                                    <SingleTextInput
                                        textInput={<TextInput
                                            className="room-events__single-text-input"
                                            type="text"
                                            value={locationDetails}
                                            textinputsize="small-40"
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                setLocationDetails(event.target.value)
                                            }}
                                            placeholder={translation.locationDetails}
                                            name="locationDetails"
                                            autoComplete="off"
                                            maxLength={100}
                                        />}
                                        errorText={locationDetailsError}
                                        title={translation.locationDetails}
                                    />
                                )}

                                <div className="dropdown">
                                    <Dropdown
                                        itemId={formatId}
                                        setItemId={setFormatId}
                                        items={formats}
                                        placeholder={translation.chooseFormat}
                                        tabIndex={formats[0].id}
                                        selectModifier="dropdown__select--unset-width"
                                    />
                                    <p className="accordion__error-message">{formatError}</p>
                                </div>
                            </TabPanel>
                            <TabPanel>

                                <SingleTextInput
                                    textInput={<HashtagInput hashtags={keywords} setHashtags={setKeywords} />}
                                    title={translation.hashtags}
                                    errorText={keywordsError}
                                />

                                <SingleTextInput
                                    textInput={<TextInput
                                        className="room-events__single-text-input"
                                        type="text"
                                        value={admission}
                                        textinputsize="small-40"
                                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                            setAdmission(event.target.value)
                                        }}
                                        placeholder={translation.admission}
                                        name="admission"
                                        autoComplete="off"
                                        maxLength={100}
                                    />}
                                    title={translation.admission + " " + translation.optional}
                                    errorText={admissionError}
                                />

                                <SingleTextInput
                                    textInput={<TextInput
                                        className="room-events__single-text-input"
                                        type="text"
                                        value={registrationLink}
                                        textinputsize="small-40"
                                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                            setRegistrationLink(event.target.value)
                                        }}
                                        placeholder={translation.registrationLink}
                                        name="registrationLink"
                                        autoComplete="off"
                                        maxLength={100}
                                    />}
                                    title={translation.registrationLink + " " + translation.optional}
                                    errorText={registrationLinkError}
                                />

                                <div className="room-events__date-input-container">
                                    <SingleTextInput
                                        textInput={<TextInput
                                            className="room-events__date-input"
                                            type="datetime-local"
                                            value={beginDate ? `${beginDate.getFullYear()}-${String(beginDate.getMonth() + 1).padStart(2, '0')}-${String(beginDate.getDate()).padStart(2, '0')}T${String(beginDate.getHours()).padStart(2, '0')}:${String(beginDate.getMinutes()).padStart(2, '0')}` : ""}
                                            textinputsize="small-40"
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                setBeginDate(event.target.value ? new Date(event.target.value) : null)
                                                if (!endDate) {
                                                    setEndDate(event.target.value ? new Date(event.target.value) : null)
                                                }
                                            }}
                                            placeholder={translation.eventDate}
                                            name="beginDate"
                                            autoComplete="off"
                                        />}
                                        errorText={startDateError}
                                        title={translation.eventStart}
                                    />
                                </div>
                                <div className="room-events__date-input-container">

                                    <SingleTextInput
                                        textInput={<TextInput
                                            className="room-events__date-input"
                                            type="datetime-local"
                                            value={endDate ? `${endDate.getFullYear()}-${String(endDate.getMonth() + 1).padStart(2, '0')}-${String(endDate.getDate()).padStart(2, '0')}T${String(endDate.getHours()).padStart(2, '0')}:${String(endDate.getMinutes()).padStart(2, '0')}` : ""}
                                            textinputsize="small-40"
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                const selectedEndDate = event.target.value ? new Date(event.target.value) : null;
                                                if (selectedEndDate && beginDate && selectedEndDate < beginDate) {
                                                    setEndDateError("Das Ende deiner Veranstaltung kann nicht vor dem Anfang liegen.");
                                                } else {
                                                    setEndDateError("");
                                                    setEndDate(selectedEndDate);
                                                }
                                            }}
                                            placeholder={translation.eventDate}
                                            name="endDate"
                                            autoComplete="off"
                                        />}
                                        errorText={endDateError}
                                        title={translation.eventEnd}
                                    />
                                </div>

                                <div>
                                    <div className="single-text-input__text">Titelbild {translation.optional}</div>
                                    <div
                                        className="room-upload-modal__file-upload"
                                        onClick={() => {
                                            const fileInput = document.getElementById("file-upload") as HTMLInputElement | null;
                                            if (fileInput) {
                                                fileInput.click();
                                            }
                                        }}
                                        onDrop={(event) => {
                                            event.preventDefault()
                                            if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
                                                const file = event.dataTransfer.files[0]
                                                if (!file.type.startsWith("image/")) {
                                                    setServerError("Bitte nur Bilddateien hochladen.")
                                                    return
                                                }
                                                setServerError("")
                                                setFileName(file.name)
                                                setFileSelected(true)
                                                const reader = new FileReader()
                                                reader.readAsDataURL(file)
                                                reader.addEventListener("load", () => {
                                                    setFile(file)
                                                })
                                            }
                                        }}
                                        onDragOver={(event) => event.preventDefault()}
                                    >
                                        <input
                                            type="file"
                                            id="file-upload"
                                            style={{ display: "none" }}
                                            accept="image/*"
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                if (event.target.files && event.target.files.length > 0) {
                                                    const file = event.target.files[0]
                                                    if (!file.type.startsWith("image/")) {
                                                        setServerError("Bitte nur Bilddateien hochladen.")
                                                        return
                                                    }
                                                    setServerError("")
                                                    setFileName(file.name)
                                                    setFileSelected(true)

                                                    const reader = new FileReader()
                                                    reader.readAsDataURL(file)
                                                    reader.addEventListener("load", () => {
                                                        setFile(file)
                                                    })
                                                }
                                            }}
                                        />
                                        <label
                                            htmlFor="file-upload"
                                            className="room-upload-modal__file-upload-label"
                                            style={{ display: "block", cursor: "pointer" }}
                                        >
                                            {fileselected ? fileName : translation.dragAndDropFile}
                                        </label>
                                        {fileselected && (
                                            <div
                                                className="room-upload-modal__delete-file-button"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setFileName("")
                                                    setFileSelected(false)
                                                    setFile(null)
                                                    setServerError("")
                                                }}
                                            >
                                                <CloseIcon />
                                            </div>
                                        )}
                                    </div>
                                </div>


                            </TabPanel>
                            <TabPanel>
                                <SingleTextInput
                                    textInput={<TextInput
                                        className="room-events__single-text-input"
                                        type="text"
                                        value={mail}
                                        textinputsize="small-40"
                                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                            setMail(event.target.value)
                                        }}
                                        placeholder={translation.mail}
                                        name="mail"
                                        autoComplete="off"
                                        maxLength={100}
                                    />}
                                    title={translation.mail + " " + translation.optional}
                                    errorText={mailError}
                                />

                                <SingleTextInput
                                    textInput={<TextInput
                                        className="room-events__single-text-input"
                                        type="text"
                                        value={website}
                                        textinputsize="small-40"
                                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                            setWebsite(event.target.value)
                                        }}
                                        placeholder={translation.website}
                                        name="website"
                                        autoComplete="off"
                                        maxLength={100}
                                    />}
                                    title={translation.website + " " + translation.optional}
                                    errorText={websiteError}
                                />

                                {props.createEvent && (
                                    <div className="event-modal__checkbox-container">
                                        <Checkbox color="dark-blue"
                                            checked={sendNotification} onChange={() => setSendNotification(!sendNotification)}
                                        />
                                        <div className="create-room-modal__text create-room-modal__text--margin-left-1">
                                            Raumbenachrichtung erstellen
                                        </div>
                                    </div>
                                )}


                                <div className={`event-modal__about-container ${!sendNotification ? 'hidden' : ''}`}>
                                    <div className="event-modal__max-character-container">
                                        <div className="event-modal__text-area">
                                            <EditorTextArea
                                                inputState={notificationText}
                                                setInputState={setNotificationText}
                                                editorRef={editorRef2}
                                                editorPlaceholder={notificationText}
                                                editorHeight={98}
                                                modifier={EditorModifier.editRoomDescription}
                                                initialEditorValue={''}
                                                setContent={() => { }}
                                                enterPressed={() => { }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="event-modal__button-container">
                                    <div className="event-modal__button">
                                        <Button
                                            onClick={onSubmit}
                                            type="submit"
                                            className="button button--font-size-small button--font-weight-400 button--text-color-white  button--color-gold  button--text-color-white button--color-red button--hover-brighter button--cursor-pointer button--border-radius-05 "
                                        >
                                            {props.createEvent ? translation.create_event : translation.save}
                                        </Button>
                                    </div>
                                    <p className="event-modal__error-text">{serverError}</p>
                                </div>
                            </TabPanel>
                        </TabPanels>
                    </Tabs>
                </div>

            </div>
        </div>
    )
}

export default RoomCreateEventModal
